module.exports = __webpack_public_path__ + "static/media/vidyard.6b204656.svg";